import {Component, OnInit} from '@angular/core';
import {CountryChartData} from '../../../../models/country-chart-data.interface';
import {Master} from '../../../../../admin/models/master.interface';
import {KfChartsService} from '../../../../services/kf-charts.service';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {buildQueryParams, getFiltersFromQueryParams} from '../../../../utils/filters-utils';

@Component({
  selector: 'app-benchmark-by-year-chart',
  templateUrl: './benchmark-by-year-chart.component.html',
  styleUrls: ['./benchmark-by-year-chart.component.scss']
})
export class BenchmarkByYearChartComponent implements OnInit {

  text = '';
  subtitle = '';
  data!: CountryChartData[];
  displayUnits = 'ABSOLUTE';
  years!: number[];
  categories!: Master[];
  countryCategory!: string;
  sort = 'alph';
  countryCodes!: string[];

  constructor(private readonly kfChartsService: KfChartsService,
              private readonly router: Router,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    if (this.router.url.includes('putonmarket')) {
      this.countryCategory = 'putonmarket';
      this.text = `Put on market - Total country values`;
      this.kfChartsService.getPomCategories().subscribe(data => this.categories = data);
    }
    if (this.router.url.includes('collected')) {
      this.countryCategory = 'collected';
      this.text = `Collected - Total country values`;
      this.kfChartsService.getCollectionStreams().subscribe(data => this.categories = data);
    }
    this.activatedRoute.queryParams.subscribe((params) => {
      const search = getFiltersFromQueryParams(params);
      this.kfChartsService.getYears(this.countryCategory, 'COUNTRY_SCHEMA', search.categoryType ? search.categoryType : 'NEW')
        .subscribe(data => {
          this.years = data;
          if (!search.startYear) {
            search.startYear = data[0];
          }
          this.subtitle = search.startYear + (search.displayUnits === 'SPECIFIC' ? ' (kg/inh)' : ' (tons)');
          if (!search.categoryType) {
            search.categoryType = 'NEW';
          }
          if (!search.displayUnits) {
            search.displayUnits = 'ABSOLUTE';
          }
          this.displayUnits = search.displayUnits;
          this.kfChartsService.getBenchmarkByYearCountries(search, this.countryCategory, 'COUNTRY_SCHEMA').subscribe(
            response => this.countryCodes = response
          );
          this.kfChartsService.getBenchmarkByYear(search, this.countryCategory, 'COUNTRY_SCHEMA')
            .subscribe(response => {
              this.data = response;
            });
        });
    });
  }

  searchData(event: ChartsSearchInterface): void {
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: buildQueryParams(event)});

    if (event.displayUnits && event.displayUnits !== '') {
      this.displayUnits = event.displayUnits;
    }
    if (event.order && event.order !== '') {
      this.sort = event.order;
    }
  }

  loadCategories(event: string): void {
    if (event === 'OLD') {
      this.kfChartsService.getOldPomCategories().subscribe(data => this.categories = data);
    } else {
      this.kfChartsService.getPomCategories().subscribe(data => this.categories = data);
    }
    this.kfChartsService.getYears(this.countryCategory, 'COUNTRY_SCHEMA', event)
      .subscribe(data => this.years = data);
  }

}
